import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ChilledWallet, CustomerLedger } from 'core';

export type DisplayedLedger = CustomerLedger & {
  tradeLedger?: CustomerLedger;
  interestEarningBalance?: number;
  interestEarningBalanceUsd?: number;
  collateralLedger?: CustomerLedger;
  chilledWallet?: ChilledWallet;
};

// FIXME rename to indicate that this is used in the portfolio section only
@Injectable({
  providedIn: 'root',
})
export class SharedMessageService {
  private inputData = new BehaviorSubject(new Array<DisplayedLedger>());
  sharedMessage = this.inputData.asObservable();

  nextMessage(message: Array<DisplayedLedger>) {
    this.inputData.next(message);
  }
}
